import * as Yup from 'yup';

const phoneRegExp = /^4[0-9]{8}|^04[0-9]{8}/;

export const formSchema = () => {
  return Yup.object().shape({
    mobileNumber: Yup.string().required('Please enter a mobile number').matches(phoneRegExp, 'Please enter a valid mobile number'),
  });
};
